import CloseIcon from "@/components/icons/CloseIcon";
import toast from "react-hot-toast"

import { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { deleteCookie, getCookie } from "cookies-next";
import { useTranslation } from "next-i18next";
import { changePasswordValidation } from "@/utils/valitation/auth";
import { useBodyScrollLock } from "@/hooks/useBodyScrollLock";
import { resetNewPassword } from "@/services/auth";
import Eye from "@/components/icons/Eye";
import Eyelock from "@/components/icons/Eyelock";
import Loading from "@/components/global/Loading";

const ChangePassByEmail = ({ Context }) => {
  const { t } = useTranslation("common");
  const email = getCookie("email");
  const [show, setShow] = useState(false);

  const handleSubmit = async (values, setSubmitting) => {
    const handshake = getCookie("handshake");
    const email = getCookie("email");
    setSubmitting(true);
    const otpEmail = getCookie('otpEmail')

    const data = {
      newPassword: values.password,
      confirmPassword: values.confirmPassword,
      resetToken: otpEmail,
    }
    
    const res = await resetNewPassword(
      handshake,
      email,
      data?.newPassword,
      data?.confirmPassword,
      data?.resetToken,
    );

    setSubmitting(false);
    if (!res.data?.data) {
      toast.error(res?.error);
      Context?.dispatch({ type: "otpEmail" });
    } else {
      toast.success("User Logged In SuccesFully");
      Context?.dispatch({ type: "changePassByEmail" });
      Context?.dispatch({ type: "auth" });
      deleteCookie("otpEmail")
      deleteCookie("email")
    }
  };
  useBodyScrollLock();
  return (
    <div className="w-11/12 mx-auto min-[450px]:w-[450px] p-3.5 bg-white rounded-md">
      <div className="flex items-center justify-between pb-2 border-b">
        <h2 className="font-bold sm:text-xl">{t("Verify Otp")}</h2>
        <CloseIcon
          onClick={() => Context?.dispatch({ type: "changePassByEmail" })}
          className="cursor-pointer text-secondary-800 size-3"
        />
      </div>
      <p className="my-2 text-center max-sm:text-sm">
        <span className="font-bold text-secondary-800">
          {t("OTP verification")}{" "}
        </span>
        <span className="mx-1 text-zinc-500">
          {t("verify OTP that send to your email")}: {email}
        </span>
      </p>

      <Formik
        initialValues={{ password: '', confirmPassword: '' }}
        onSubmit={(values, { setSubmitting, setFieldError }) => {
          handleSubmit(values, setSubmitting, setFieldError);
        }}
        validationSchema={changePasswordValidation(t)}
      >
        {({ isSubmitting }) => (
          <Form className='mt-2.5 *:mb-2.5'>
            <div>
              <div className='relative *:mb-1'>
                <Field
                  name='password'
                  type={!show ? 'password' : 'text'}
                  className='w-full rounded-sm border p-1.5 outline-none max-sm:placeholder:text-sm'
                  placeholder={t('Password')}
                />
                {show ? (
                  <Eye
                    onClick={() => setShow(!show)}
                    className='absolute end-2 top-1/2 z-20 size-4 -translate-y-1/2 text-zinc-500'
                  />
                ) : (
                  <Eyelock
                    onClick={() => setShow(!show)}
                    className='absolute end-2 top-1/2 z-20 size-4 -translate-y-1/2 text-zinc-500'
                  />
                )}
              </div>
              <ErrorMessage
                name='password'
                component='p'
                className='text-sm text-red-600'
              />
            </div>
            <div>
              <div className='relative *:mb-1'>
                <Field
                  name='confirmPassword'
                  type={!show ? 'password' : 'text'}
                  className='w-full rounded-sm border p-1.5 outline-none max-sm:placeholder:text-sm'
                  placeholder={t('Confirm Password')}
                />
                {show ? (
                  <Eye
                    onClick={() => setShow(!show)}
                    className='absolute end-2 top-1/2 z-20 size-4 -translate-y-1/2 text-zinc-500'
                  />
                ) : (
                  <Eyelock
                    onClick={() => setShow(!show)}
                    className='absolute end-2 top-1/2 z-20 size-4 -translate-y-1/2 text-zinc-500'
                  />
                )}
              </div>
              <ErrorMessage
                name='confirmPassword'
                component='p'
                className='text-sm text-red-600'
              />
            </div>
            <button
              type='submit'
              disabled={isSubmitting}
              className='mt-1 max-sm:text-sm bg-primary text-white p-1.5 rounded-sm w-full font-semibold uppercase'
            >
              {isSubmitting ? (
                <Loading /> 
              ) : (
                t('Confirm')
              )}
            </button>
          </Form>
        )}
      </Formik>

    </div>
  );
};

export default ChangePassByEmail